import { Injectable } from '@angular/core';
import { CustomHttpService } from "@services/generals/custom-http.service";
import { Module } from "@models/module";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private modules: Module[] = [];
  constructor(
    public customHttpService: CustomHttpService,
  ) { }

  public login = (userName: string, password: string) => {
    const self = this;
    const request = {
      email: userName,
      password
    };
    return new Promise(
      resolve => {
        self.customHttpService.httpPOST(true, true, 'v1/api/Auth/AuthCMS', request).then(
          (response: any) => {
            if (response === false) { resolve(response); }
            else {
              sessionStorage.setItem('session', JSON.stringify(response.session));
              response.usuario.listRoles.map( (e: any) => {
                e.role.listModulos.map((i: any) => {
                  var exist = false;
                  this.modules.find(m => exist = m.moduloID == i.modulo.moduloID);
                  if (!exist) {
                    this.modules.push(i.modulo);
                  }
                })
              });
              // sessionStorage.setItem('usuario', JSON.stringify(response.usuario));
              sessionStorage.setItem('modules', JSON.stringify(this.modules));

              // sessionStorage.setItem('token', response.session.token);
              // sessionStorage.setItem('email', response.session.user.email);
              // sessionStorage.setItem('role', response.session.user.roleGroupID);
              // sessionStorage.setItem('role_name', response.session.user.roleGroupID.roleGroupName);
              resolve(response);
            }
          }
        );
      }
    );
  }

  public logout = () => {
    sessionStorage.clear();
  }

  public isAuthenticated = (): boolean => {
    return !!sessionStorage.getItem('session');
  }

}
